import bigInt from 'big-integer'

export default {
  'ModTools': {
    'Name': 'Mod Tools',
    'Permissions': {
      'AbleToLogin': {
        'Name': 'Login',
        'Description': 'Members with this permission have access to the mod tools.',
        'Permission': bigInt(2).pow(1),
        'icon': 'fa fa-sign-in',
      },
      'CurrentOnlineToolTip': {
        'Name': 'Currently Online Tooltip',
        'Description': 'Members with this permission can view detailed online statistics.',
        'Permission': bigInt(2).pow(70),
        'Important': true,
        'icon': 'fa fa-users',
      },
      'ToolsLogView': {
        'Name': 'System Log',
        'Description': 'Members with this permission can view application logs.',
        'Permission': bigInt(2).pow(68),
        'Important': true,
        'icon': 'fa fa-file-text-o',
      },
      'ToolsRestart': {
        'Name': 'Restart',
        'Description': 'Members with this permission can restart this application.',
        'Permission': bigInt(2).pow(69),
        'Important': true,
        'icon': 'fa fa-refresh',
      },
      'PermissionView': {
        'Name': 'Permissions View',
        'Description': 'Members with this permission can view permission assignments.',
        'Permission': bigInt(2).pow(48),
        'icon': 'fa fa-eye',
      },
      'PermissionChange': {
        'Name': 'Permissions Edit',
        'Description': 'Members with this permission can edit the user and group permissions.',
        'Permission': bigInt(2).pow(49),
        'Important': true,
        'icon': 'fa fa-shield',
      },
      'AuditlogView': {
        'Name': 'Audit Log View',
        'Description': 'Members with this permission can view a record of staff actions.',
        'Permission': bigInt(2).pow(29),
        'icon': 'fa fa-list-alt',
      },
    },
  },

  'AccountBasics': {
    'Name': 'Account Basics',
    'Permissions': {
      'UserView': {
        'Name': 'Profile View',
        'Description': 'Members with this permission can view the base user page.',
        'Permission': bigInt(2).pow(3),
        'icon': 'fa fa-user',
      },
      'UserLoginMessage': {
        'Name': 'In-Game Notification',
        'Description': 'Members with this permission can send login messages.',
        'Permission': bigInt(2).pow(2),
        'icon': 'fa fa-commenting-o',
      },
      'UserGuildHistoryView': {
        'Name': 'Guild History View',
        'Description': "Members with this permission can view user's guild histories.",
        'Permission': bigInt(2).pow(61),
        'icon': 'fa fa-group',
      },
      'ApprovedDevicesView': {
        'Name': 'Approved 2FA Devices View',
        'Description': 'Members with this permission can view a user\'s approved devices.',
        'Permission': bigInt(2).pow(90),
        'icon': 'fa fa-mobile',
      },
      'ApprovedDevicesDelete': {
        'Name': 'Approved 2FA Devices Delete',
        'Description': 'Members with this permission can delete a user\'s approved devices.',
        'Permission': bigInt(2).pow(91),
        'icon': 'fa fa-trash',
        'Important': true,
      },
      'ViewPokedex': {
        'Name': 'Pokedex View',
        'Description': 'Members with this permission can view the Pokedex page.',
        'Permission': bigInt(2).pow(27),
        'icon': 'fa fa-book',
      },
    },
  },

  'AccountInvestigation': {
    'Name': 'Account Investigation',
    'Permissions': {
      'UserHistoryView': {
        'Name': 'Account History View',
        'Description': "Members with this permission can view user's website-related histories.",
        'Permission': bigInt(2).pow(55),
        'icon': 'fa fa-history',
      },
      'UserInfractionView': {
        'Name': 'Infraction History View',
        'Description': "Members with this permission can view user's infractions.",
        'Permission': bigInt(2).pow(54),
        'icon': 'fa fa-warning',
      },
      'UserInfractionDelete': {
        'Name': 'Infraction History Delete',
        'Description': "Members with this permission can delete user's infractions.",
        'Permission': bigInt(2).pow(104),
        'icon': 'fa fa-trash',
        'Important': true,
      },
      'UserIPsEmailView': {
        'Name': "IP & E-Mail View",
        'Description': 'Members with this permission can view E-Mail and IP addresses.',
        'Permission': bigInt(2).pow(4),
        'icon': 'fa fa-globe',
      },
      'UserMacView': {
        'Name': 'MAC Address View',
        'Description': 'Members with this permission can view mac addresses.',
        'Permission': bigInt(2).pow(52),
        'icon': 'fa fa-desktop',
      },
      'ConnectionsView': {
        'Name': 'Identity & Ownership Analysis',
        'Description': 'Members with this permission can view player connection links.',
        'Permission': bigInt(2).pow(26),
        'icon': 'fa fa-link',
      },
      'MacroView': {
        'Name': 'Macro Report View',
        'Description': 'Members with this permission can view macro statistics and details.',
        'Permission': bigInt(2).pow(89),
        'icon': 'fa fa-keyboard-o',
      },
      'UserNotesView': {
        'Name': 'Profile Notes View',
        'Description': 'Members with this permission can view the notes of a user.',
        'Permission': bigInt(2).pow(75),
        'icon': 'fa fa-sticky-note-o',
      },
      'UserNotesEdit': {
        'Name': 'Profile Notes Edit',
        'Description': 'Members with this permission can edit the notes of a user.',
        'Permission': bigInt(2).pow(76),
        'icon': 'fa fa-pencil-square-o',
      },
    },
  },

  'AccountEditing': {
    'Name': 'Account Editing',
    'Permissions': {
      'UserNameChange': {
        'Name': 'Username Change',
        'Description': 'Members with this permission can change usernames.',
        'Permission': bigInt(2).pow(5),
        'icon': 'fa fa-id-card-o',
      },
      'UserEmailChange': {
        'Name': 'E-Mail Change',
        'Description': "Members with this permission can change a user's e-mail address.",
        'Permission': bigInt(2).pow(6),
        'icon': 'fa fa-envelope-o',
        'Important': true,
      },
      'UserMoneyChange': {
        'Name': 'Pokedollars Edit',
        'Description': "Members with this permission can change a user's money.",
        'Permission': bigInt(2).pow(7),
        'Important': true,
        'icon': 'fa fa-money',
      },
      'UserCoinChange': {
        'Name': 'Donation Coins Edit',
        'Description': "Members with this permission can change a user's coins.",
        'Permission': bigInt(2).pow(8),
        'Important': true,
        'icon': 'fa fa-database',
      },
      'UserServerTransfer': {
        'Name': 'Server Swap',
        'Description': 'Members with this permission can transfer accounts between servers.',
        'icon': 'fa fa-exchange',
        'Permission': bigInt(2).pow(15),
      },
      'UserReset': {
        'Name': 'Account Reset',
        'Description': 'Members with this permission can reset and demote accounts.',
        'icon': 'fa fa-undo',
        'Permission': bigInt(2).pow(14),
      },
      'UserForceMerge': {
        'Name': 'Force Merge',
        'Description': 'Members with this permission can force merge users.',
        'Permission': bigInt(2).pow(13),
        'icon': 'fa fa-compress',
      },
      'UserUnmerge': {
        'Name': 'Unmerge Account',
        'Description': 'Members with this permission can delete silver accounts with no trades.',
        'Permission': bigInt(2).pow(16),
        'icon': 'fa fa-user-times',
        'Important': true,
      },
      'UserStaffRewardsEdit': {
        'Name': 'Staff Rewards Edit',
        'Description': "Members with this permission can modify a staff member's reward balance.",
        'Permission': bigInt(2).pow(83),
        'icon': 'fa fa-gift',
      },
      'ForumGroupChange': {
        'Name': 'Forum Roles Management',
        'Description': "Members with this permission can change a user's forum group.",
        'Permission': bigInt(2).pow(82),
        'icon': 'fa fa-comments-o',
      },
    },
  },

  'BanTools': {
    'Name': 'Ban Tools',
    'Permissions': {
      'UserBan': {
        'Name': 'Ban/Unban Users',
        'Description': 'Members with this permission can ban and unban users.',
        'Permission': bigInt(2).pow(9),
        'icon': 'fa fa-ban',
      },
      'UserBanMac': {
        'Name': 'MAC Ban',
        'Description': 'Members with this permission can ban MAC addresses.',
        'Permission': bigInt(2).pow(17),
        'icon': 'fa fa-address-card-o',
        'Important': true,
      },
      'BanIP': {
        'Name': 'IP Ban',
        'Description': 'Members with this permission can ban IP addresses.',
        'Permission': bigInt(2).pow(43),
        'icon': 'fa fa-map-marker',
      },
      'SystemBanView': {
        'Name': 'System Bans View',
        'Description': 'Members with this permission can view active system-wide bans.',
        'Permission': bigInt(2).pow(88),
        'icon': 'fa fa-shield',
      },
      'MassbanView': {
        'Name': 'Massban View',
        'Description': 'Members with this permission can view the mass ban page.',
        'Permission': bigInt(2).pow(40),
        'icon': 'fa fa-list',
      },
      'MassbanUsers': {
        'Name': 'Massban by Usernames',
        'Description': 'Members with this permission can ban multiple users at once using usernames.',
        'Permission': bigInt(2).pow(41),
        'icon': 'fa fa-users',
      },
      'MassbanEMails': {
        'Name': 'Massban by E-Mails',
        'Description': 'Members with this permission can ban multiple users at once using e-mail addresses.',
        'Permission': bigInt(2).pow(42),
        'icon': 'fa fa-envelope-open',
      },
    },
  },

  'AccountSnapshots': {
    'Name': 'Account Snapshots',
    'Permissions': {
      'ViewSnapshots': {
        'Name': 'Snapshots View',
        'Description': 'Members with this permission can view the snapshot list.',
        'Permission': bigInt(2).pow(33),
        'icon': 'fa fa-camera',
      },
      'SnapshotCreate': {
        'Name': 'Snapshot Create',
        'Description': "Members with this permission can create a copy of a user's data.",
        'Permission': bigInt(2).pow(34),
        'icon': 'fa fa-save',
      },
      'SnapshotRestore': {
        'Name': 'Snapshot Restore',
        'Description': "Members with this permission can replace current data with snapshot data.",
        'Permission': bigInt(2).pow(35),
        'icon': 'fa fa-upload',
        'Important': true,
      },
      'SnapshotRestoreOwnTest': {
        'Name': 'Snapshot Clone to Test',
        'Description': "Members with this permission can clone snapshots to their own account on the test server.",
        'Permission': bigInt(2).pow(124),
        'icon': 'fa fa-flask',
        'Important': true,
      },
      'BrowseSnapShot': {
        'Name': 'Snapshot Browse',
        'Description': "Members with this permission can browse through stored snapshot data.",
        'Permission': bigInt(2).pow(71),
        'Important': true,
        'icon': 'fa fa-folder-open-o',
      },
    },
  },

  'TradesInGameMails': {
    'Name': 'Trades & In-Game Mails',
    'Permissions': {
      'TradelogsView': {
        'Name': 'Trade Log View',
        'Description': 'Members with this permission can view detailed trade histories.',
        'Permission': bigInt(2).pow(25),
        'icon': 'fa fa-handshake-o',
      },
      'TradelogsRevert': {
        'Name': 'Trade Revert',
        'Description': 'Members with this permission can revert eligible trade log entries.',
        'Permission': bigInt(2).pow(123),
        'icon': 'fa fa-undo',
        'Important': true,
      },
      'UserMailsView': {
        'Name': 'In-Game Mails View',
        'Description': 'Members with this permission can view user mails.',
        'Permission': bigInt(2).pow(84),
        'icon': 'fa fa-envelope',
      },
      'UserMailsReadContent': {
        'Name': 'In-Game Mails Message View',
        'Description': 'Members with this permission can read the content of user mails.',
        'Permission': bigInt(2).pow(87),
        'icon': 'fa fa-eye',
        'Important': true,
      },
      'UserMailsDelete': {
        'Name': 'In-Game Mails Delete',
        'Description': 'Members with this permission can delete user mails.',
        'Permission': bigInt(2).pow(85),
        'icon': 'fa fa-trash',
      },
      'UserMailsRestore': {
        'Name': 'In-Game Mails Restore',
        'Description': 'Members with this permission can restore deleted user mails.',
        'Permission': bigInt(2).pow(94),
        'icon': 'fa fa-undo',
      },
      'UserMailsRestoreItem': {
        'Name': 'In-Game Mails Item Restore',
        'Description': 'Members with this permission can restore deleted mail items.',
        'Permission': bigInt(2).pow(99),
        'icon': 'fa fa-undo',
      },
    },
  },

  'ItemsInventory': {
    'Name': 'Items & Inventory',
    'Permissions': {
      'InventoryView': {
        'Name': 'Inventory View',
        'Description': 'Members with this permission can view the inventory page.',
        'Permission': bigInt(2).pow(36),
        'icon': 'fa fa-briefcase',
      },
      'InventoryAddItem': {
        'Name': 'Inventory Add',
        'Description': "Members with this permission can add items to inventories.",
        'Permission': bigInt(2).pow(37),
        'Important': true,
        'icon': 'fa fa-plus-circle',
      },
      'InventoryEditItem': {
        'Name': 'Inventory Edit',
        'Description': 'Members with this permission can change item amounts.',
        'Permission': bigInt(2).pow(38),
        'Important': true,
        'icon': 'fa fa-pencil',
      },
      'InventoryRemoveItem': {
        'Name': 'Inventory Delete',
        'Description': "Members with this permission can remove items from inventories.",
        'Permission': bigInt(2).pow(39),
        'icon': 'fa fa-minus-circle',
      },
      'MoveClothesToInventory': {
        'Name': 'Undress Equipped Cosmetics to Inventory',
        'Description': 'Members with this permission can move equipped clothes back to inventory.',
        'Permission': bigInt(2).pow(65),
        'icon': 'fa fa-shopping-bag',
      },
    },
  },

  'ItemLog': {
    'Name': 'Item Log',
    'Permissions': {
      'ItemLogScriptView': {
        'Name': 'Script',
        'Description': 'Members with this permission can view item logs for Script context.',
        'Permission': bigInt(2).pow(109),
        'icon': 'fa fa-code',
      },
      'ItemLogPythonShopView': {
        'Name': 'Python Shop',
        'Description': 'Members with this permission can view item logs for Python Shop context.',
        'Permission': bigInt(2).pow(110),
        'icon': 'fa fa-shopping-cart',
      },
      'ItemLogCoinShopView': {
        'Name': 'Coin Shop',
        'Description': 'Members with this permission can view item logs for Coin Shop context.',
        'Permission': bigInt(2).pow(111),
        'icon': 'fa fa-database',
      },
      'ItemLogAfterBattleHeldItemView': {
        'Name': 'After Battle Held Item',
        'Description': 'Members with this permission can view item logs for After Battle Held Item context.',
        'Permission': bigInt(2).pow(112),
        'icon': 'fa fa-shield',
      },
      'ItemLogLootboxView': {
        'Name': 'Lootbox',
        'Description': 'Members with this permission can view item logs for Lootbox context.',
        'Permission': bigInt(2).pow(113),
        'icon': 'fa fa-archive',
      },
      'ItemLogLootboxDropView': {
        'Name': 'Lootbox Drop',
        'Description': 'Members with this permission can view item logs for Lootbox Drop context.',
        'Permission': bigInt(2).pow(114),
        'icon': 'fa fa-dropbox',
      },
      'ItemLogInventoryDeleteView': {
        'Name': 'Inventory Delete',
        'Description': 'Members with this permission can view item logs for Inventory Delete context.',
        'Permission': bigInt(2).pow(115),
        'icon': 'fa fa-trash',
      },
      'ItemLogStaffCommandView': {
        'Name': 'Staff Command',
        'Description': 'Members with this permission can view item logs for Staff Command context.',
        'Permission': bigInt(2).pow(116),
        'icon': 'fa fa-terminal',
      },
      'ItemLogUseView': {
        'Name': 'Use',
        'Description': 'Members with this permission can view item logs for Use context.',
        'Permission': bigInt(2).pow(117),
        'icon': 'fa fa-hand-pointer-o',
      },
      'ItemLogEvolutionView': {
        'Name': 'Evolution',
        'Description': 'Members with this permission can view item logs for Evolution context.',
        'Permission': bigInt(2).pow(118),
        'icon': 'fa fa-level-up',
      },
      'ItemLogMailView': {
        'Name': 'Mail',
        'Description': 'Members with this permission can view item logs for Mail context.',
        'Permission': bigInt(2).pow(119),
        'icon': 'fa fa-envelope',
      },
    },
  },

  'Variables': {
    'Name': 'Variables',
    'Permissions': {
      'VariablesView': {
        'Name': 'User Variables View',
        'Description': 'Members with this permission can view the variable page.',
        'Permission': bigInt(2).pow(30),
        'icon': 'fa fa-cube',
      },
      'VariablesEdit': {
        'Name': 'User Variables Edit',
        'Description': "Members with this permission can edit users' variables.",
        'Permission': bigInt(2).pow(31),
        'Important': true,
        'icon': 'fa fa-edit',
      },
      'VariablesEditDays': {
        'Name': 'User Variables Date Edit',
        'Description': 'Members with this permission can edit the days of user variables.',
        'Permission': bigInt(2).pow(74),
        'Important': true,
        'icon': 'fa fa-calendar',
      },
      'VariablesDelete': {
        'Name': 'User Variables Delete',
        'Description': "Members with this permission can delete users' variables.",
        'Permission': bigInt(2).pow(32),
        'Important': true,
        'icon': 'fa fa-eraser',
      },
      'GlobalVarsView': {
        'Name': 'Global Variables View',
        'Description': 'Members with this permission can view global game variables.',
        'Permission': bigInt(2).pow(50),
        'icon': 'fa fa-globe',
      },
      'GlobalVarsDelete': {
        'Name': 'Global Variables Delete',
        'Description': 'Members with this permission can delete global game variables.',
        'Permission': bigInt(2).pow(51),
        'Important': true,
        'icon': 'fa fa-times-circle',
      },
      'ScriptErrorsView': {
        'Name': 'Script Errors View',
        'Description': 'Members with this permission can view grouped script traceback errors.',
        'Permission': bigInt(2).pow(125),
        'icon': 'fa fa-bug',
      },
    },
  },

  'ModerationTools': {
    'Name': 'Moderation Tools',
    'Permissions': {
      'ChatlogView': {
        'Name': 'Chat Log View',
        'Description': 'Members with this permission have access to view the in-game chat log.',
        'Permission': bigInt(2).pow(58),
        'icon': 'fa fa-comments',
      },
      'WatchlistView': {
        'Name': 'Watchlist View',
        'Description': 'Members with this permission can access the watch list of suspicious users.',
        'Permission': bigInt(2).pow(62),
        'icon': 'fa fa-binoculars',
      },
      'WatchlistAdd': {
        'Name': 'Watchlist Add',
        'Description': 'Members with this permission can add users to the watch list.',
        'Permission': bigInt(2).pow(63),
        'icon': 'fa fa-plus-circle',
      },
      'WatchlistDelete': {
        'Name': 'Watchlist Delete',
        'Description': 'Members with this permission can remove users from the watch list.',
        'Permission': bigInt(2).pow(64),
        'icon': 'fa fa-minus-circle',
      },
      'PlaytimeView': {
        'Name': 'Session Time View',
        'Description': "Members with this permission can view yesterday's session time toplist.",
        'Permission': bigInt(2).pow(105),
        'icon': 'fa fa-clock-o',
      },
    },
  },

  'PokemonModeration': {
    'Name': 'Pokemon Moderation',
    'Permissions': {
      'PokemonView': {
        'Name': 'Pokemon View',
        'Description': 'Members with this permission can view the Pokemon page.',
        'Permission': bigInt(2).pow(18),
        'icon': 'fa fa-paw',
      },
      'PokemonRecover': {
        'Name': 'Recover deleted by User',
        'Description': 'Members with this permission can recover deleted Pokemon.',
        'Permission': bigInt(2).pow(19),
        'icon': 'fa fa-heartbeat',
      },
      'PokemonRecoverScript': {
        'Name': 'Recover deleted by Script',
        'Description': 'Members with this permission can recover script deleted pokemon.',
        'Permission': bigInt(2).pow(77),
        'Important': true,
        'icon': 'fa fa-code',
      },
      'PokemonDelete': {
        'Name': 'Delete to -1',
        'Description': 'Members with this permission can delete Pokemon.',
        'Permission': bigInt(2).pow(20),
        'icon': 'fa fa-trash-o',
      },
      'PokemonOwnerTransfer': {
        'Name': 'Transfer Ownership',
        'Description': 'Members with this permission can transfer Pokemon between players.',
        'Permission': bigInt(2).pow(21),
        'Important': true,
        'icon': 'fa fa-handshake-o',
      },
      'PokemonOwnerTransferScript': {
        'Name': 'Transfer deleted by Script',
        'Description': 'Members with this permission can transfer script deleted Pokemon.',
        'Permission': bigInt(2).pow(108),
        'Important': true,
        'icon': 'fa fa-code-fork',
      },
      'PokemonServerTransfer': {
        'Name': 'Transfer Gold/Silver',
        'Description': 'Members with this permission can transfer Pokemon between Gold and Silver for the same player.',
        'Permission': bigInt(2).pow(121),
        'Important': true,
        'icon': 'fa fa-exchange',
      },
      'PokemonHeldItemToInventory': {
        'Name': 'Held Item to Inventory',
        'Description': "Members with this permission can move a Pokemon's held item into the owner's inventory.",
        'Permission': bigInt(2).pow(122),
        'Important': true,
        'icon': 'fa fa-briefcase',
      },
      'PokemonDelevel': {
        'Name': 'Delevel by 1',
        'Description': 'Members with this permission can reduce Pokemon levels.',
        'Permission': bigInt(2).pow(22),
        'icon': 'fa fa-level-down',
      },
      'PokemonAddView': {
        'Name': 'Request a Pokemon',
        'Description': 'Members with this permission can access the pokemon add request interface.',
        'Permission': bigInt(2).pow(24),
        'icon': 'fa fa-plus-square-o',
      },
      'PokemonAdd': {
        'Name': 'Add a Pokemon/Approve Requests',
        'Description': 'Members with this permission can generate and approve new Pokemon.',
        'Permission': bigInt(2).pow(23),
        'Important': true,
        'icon': 'fa fa-plus',
      },
    },
  },

  'PokemonEditing': {
    'Name': 'Pokemon Editing',
    'Permissions': {
      'PokemonEditAbility': {
        'Name': 'Ability Edit',
        'Description': "Members with this permission can change a Pokemon's ability.",
        'Permission': bigInt(2).pow(53),
        'icon': 'fa fa-flash',
        'Important': true,
      },
      'PokemonEditNature': {
        'Name': 'Nature Edit',
        'Description': "Members with this permission can change a Pokemon's nature.",
        'Permission': bigInt(2).pow(56),
        'icon': 'fa fa-leaf',
        'Important': true,
      },
      'PokemonEditOT': {
        'Name': 'Original Trainer Edit',
        'Description': "Members with this permission can change a Pokemon's OT.",
        'Permission': bigInt(2).pow(57),
        'icon': 'fa fa-user-circle-o',
        'Important': true,
      },
      'PokemonEditTradeLock': {
        'Name': 'Trade-Lock Edit',
        'Description': 'Members with this permission can trade lock and unlock a Pokemon.',
        'Permission': bigInt(2).pow(59),
        'icon': 'fa fa-lock',
        'Important': true,
      },
      'PokemonEditIVS': {
        'Name': 'Individual Values Edit',
        'Description': "Members with this permission can change a Pokemon's Individual Values.",
        'Permission': bigInt(2).pow(60),
        'icon': 'fa fa-bar-chart',
        'Important': true,
      },
      'PokemonEditForm': {
        'Name': 'Form Edit',
        'Description': "Members with this permission can change a Pokemon's form.",
        'Permission': bigInt(2).pow(66),
        'Important': true,
        'icon': 'fa fa-clone',
      },
    },
  },

  'PlayerVersusPlayer': {
    'Name': 'Player versus Player',
    'Permissions': {
      'PVPlogView': {
        'Name': 'PvP Log View',
        'Description': 'Members with this permission can view detailed PVP match logs.',
        'Permission': bigInt(2).pow(28),
        'Important': true,
        'icon': 'fa fa-crosshairs',
      },
      'UserRatingChange': {
        'Name': 'PvP Rating Edit',
        'Description': "Members with this permission can change a user's PVP rating.",
        'Permission': bigInt(2).pow(12),
        'icon': 'fa fa-trophy',
        'Important': true,
      },
      'SavedLaddersView': {
        'Name': 'PvP Ladders View',
        'Description': 'Members with this permission can view archived ladder rankings.',
        'Permission': bigInt(2).pow(81),
        'Important': true,
        'icon': 'fa fa-list-ol',
      },
      'PVPStatisticsDL': {
        'Name': 'PvP Top Lists Download',
        'Description': 'Members with this permission can download bulk PVP statistics.',
        'Permission': bigInt(2).pow(11),
        'icon': 'fa fa-download',
      },
      'PvpRulesView': {
        'Name': 'PvP Rules View',
        'Description': 'Members with this permission can view pvp rules.',
        'Permission': bigInt(2).pow(95),
        'icon': 'fa fa-gavel',
      },
      'PvpRulesEdit': {
        'Name': 'PvP Rules Edit',
        'Description': 'Members with this permission can edit pvp rules.',
        'Permission': bigInt(2).pow(96),
        'Important': true,
        'icon': 'fa fa-edit',
      },
      'PvpRewardsView': {
        'Name': 'PvP Rewards View',
        'Description': 'Members with this permission can view pvp rewards.',
        'Permission': bigInt(2).pow(97),
        'icon': 'fa fa-gift',
      },
      'PvpRewardsEdit': {
        'Name': 'PvP Rewards Edit',
        'Description': 'Members with this permission can edit pvp rewards.',
        'Permission': bigInt(2).pow(98),
        'Important': true,
        'icon': 'fa fa-edit',
      },
      'SuspectMatches': {
        'Name': 'Suspect PvP Ranked Matches View',
        'Description': 'Members with this permission can view legitimate ranked match alerts.',
        'Permission': bigInt(2).pow(72),
        'icon': 'fa fa-legal',
      },
      'PvpBanlistView': {
        'Name': 'PvP Banlist View',
        'Description': 'Members with this permission can view the PvP banlist.',
        'Permission': bigInt(2).pow(100),
        'icon': 'fa fa-ban',
      },
      'PvpBanlistEdit': {
        'Name': 'PvP Banlist Edit',
        'Description': 'Members with this permission can add and delete PvP banlist rules.',
        'Permission': bigInt(2).pow(101),
        'Important': true,
        'icon': 'fa fa-ban',
      },
      'PvpRandomSetsView': {
        'Name': 'PvP Random Sets View',
        'Description': 'Members with this permission can view random battle sets.',
        'Permission': bigInt(2).pow(102),
        'icon': 'fa fa-random',
      },
      'PvpRandomSetsEdit': {
        'Name': 'PvP Random Sets Edit',
        'Description': 'Members with this permission can add, edit, and delete random battle sets.',
        'Permission': bigInt(2).pow(103),
        'Important': true,
        'icon': 'fa fa-random',
      },
      'PvpUsageStatsView': {
        'Name': 'PvP Usage Stats View',
        'Description': 'Members with this permission can view monthly PvP Pokemon usage statistics.',
        'Permission': bigInt(2).pow(120),
        'icon': 'fa fa-bar-chart',
      },
    },
  },

  'News': {
    'Name': 'News',
    'Permissions': {
      'WebsiteNewsView': {
        'Name': 'News Website View',
        'Description': 'Members with this permission can view the website news management page.',
        'Permission': bigInt(2).pow(44),
        'icon': 'fa fa-newspaper-o',
      },
      'NewsCreate': {
        'Name': 'News Website Create',
        'Description': 'Members with this permission can write homepage news.',
        'Permission': bigInt(2).pow(45),
        'icon': 'fa fa-pencil-square',
      },
      'NewsEdit': {
        'Name': 'News Website Edit',
        'Description': 'Members with this permission can edit existing news.',
        'Permission': bigInt(2).pow(46),
        'icon': 'fa fa-edit',
      },
      'NewsDelete': {
        'Name': 'News Website Delete',
        'Description': 'Members with this permission can delete news entries.',
        'Permission': bigInt(2).pow(47),
        'icon': 'fa fa-trash-o',
      },
      'IngameNewsView': {
        'Name': 'News Client Login Screen View',
        'Description': 'Members with this permission can view the ingame news management page.',
        'Permission': bigInt(2).pow(93),
        'icon': 'fa fa-eye',
      },
      'IngameNewsEdit': {
        'Name': 'News Client Login Screen Edit',
        'Description': 'Members with this permission can edit the news.txt (ingame news).',
        'Permission': bigInt(2).pow(92),
        'icon': 'fa fa-edit',
      },
    },
  },

  'ContentEditors': {
    'Name': 'Content Editors',
    'Permissions': {
      'PROEditorApprenticeRestrictions': {
        'Name': 'Content Editor Apprentice Maps Only',
        'Description': 'Limited map server access for apprentices.',
        'Permission': bigInt(2).pow(78),
        'Important': true,
        'icon': 'fa fa-mortar-board',
      },
      'PROEditorScriptUpload': {
        'Name': 'Content Editor Scripts Access',
        'Description': 'Upload scripts directly to the map server.',
        'Permission': bigInt(2).pow(79),
        'Important': true,
        'icon': 'fa fa-upload',
      },
      'PROEditorMapUpload': {
        'Name': 'Content Editor Map Upload',
        'Description': 'Upload maps directly to the map server.',
        'Permission': bigInt(2).pow(80),
        'Important': true,
        'icon': 'fa fa-map-o',
      },
      'SpawnsView': {
        'Name': 'Spawns View in Spawn Editor',
        'Description': 'Members with this permission can view raw spawn rates and data.',
        'Permission': bigInt(2).pow(67),
        'Important': true,
        'icon': 'fa fa-map',
      },
    },
  },

  'DeveloperTools': {
    'Name': 'Developer Tools',
    'Permissions': {
      'ForceRestart': {
        'Name': 'Game Server Restart',
        'Description': 'Members with this permission can force a game server reboot.',
        'Permission': bigInt(2).pow(10),
        'icon': 'fa fa-power-off',
      },
      'ToolsReloadData': {
        'Name': 'Reload Tools Data',
        'Description': 'Members with this permission can reload static data cached by the tools.',
        'Permission': bigInt(2).pow(86),
        'Important': true,
        'icon': 'fa fa-refresh',
      },
      'MailLogView': {
        'Name': 'E-Mail Server Log',
        'Description': 'Members with this permission can view system-wide mail logs.',
        'Permission': bigInt(2).pow(73),
        'Important': true,
        'icon': 'fa fa-archive',
      },
      'EmailRoutingView': {
        'Name': 'E-Mail Routing View',
        'Description': 'Members with this permission can view email provider routing rules.',
        'Permission': bigInt(2).pow(106),
        'Important': true,
        'icon': 'fa fa-random',
      },
      'EmailRoutingEdit': {
        'Name': 'E-Mail Routing Edit',
        'Description': 'Members with this permission can change email provider routing rules.',
        'Permission': bigInt(2).pow(107),
        'Important': true,
        'icon': 'fa fa-random',
      },
    },
  },
}
